var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9288 12.2993H6.03108C5.49699 12.2993 5.23562 11.6516 5.62199 11.288L14.0765 3.09482C14.4856 2.6971 15.1561 3.09482 15.0083 3.64028L10.622 19.913C10.4743 20.4584 11.1447 20.8562 11.5538 20.4584L20.0084 12.2652C20.3947 11.8902 20.1333 11.2539 19.5993 11.2539H13.4743",
    stroke: "#207C97",
    strokeWidth: 1.47727,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarter);
export default __webpack_public_path__ + "static/media/starter.fabd6544308d4ea24f4553431a19fea1.svg";
export { ForwardRef as ReactComponent };